import sessionStore from '@/stores/session';
import { TRACKING_OPERATION } from '@/utils/constants';
import { chatbotTrackObj } from '..';

// 监听上报的意图,暂不考虑 premium user
export function exitTrack() {
  return chatbotTrackObj.report({
    operation: TRACKING_OPERATION.EXIT,
    data: { function: sessionStore.curFunction },
  });
}
